import { createSelector } from 'reselect';

export const getThanksModalIsOpened = (state) => state?.thanksModal?.opened;

export const thanksModalIsOpenedSelector = createSelector(
  [getThanksModalIsOpened],
  (opened) => opened,
);
